import { OutlineViewer } from '@blocksuite/affine/fragments/outline';
import type { EditorHost } from '@blocksuite/affine/std';
import { useCallback, useEffect, useRef } from 'react';

import * as styles from './outline-viewer.css';

export const EditorOutlineViewer = ({
  editor,
  show,
  openOutlinePanel,
}: {
  editor: EditorHost | null;
  show: boolean;
  openOutlinePanel?: () => void;
}) => {
  const outlineViewerRef = useRef<OutlineViewer | null>(null);

  // ✅ 清理函数：在组件卸载或 editor 变化时清理 OutlineViewer
  useEffect(() => {
    return () => {
      if (outlineViewerRef.current) {
        // 清除引用，避免内存泄漏
        outlineViewerRef.current.editor = null as any;
        outlineViewerRef.current.toggleOutlinePanel = null;
        outlineViewerRef.current.remove();
        outlineViewerRef.current = null;
      }
    };
  }, [editor]);

  const onRefChange = useCallback(
    (container: HTMLDivElement | null) => {
      // ✅ 先清理旧的 OutlineViewer
      if (outlineViewerRef.current) {
        outlineViewerRef.current.editor = null as any;
        outlineViewerRef.current.toggleOutlinePanel = null;
        outlineViewerRef.current.remove();
        outlineViewerRef.current = null;
      }

      if (container && editor) {
        outlineViewerRef.current = new OutlineViewer();
        outlineViewerRef.current.editor = editor;
        outlineViewerRef.current.toggleOutlinePanel = openOutlinePanel ?? null;
        container.append(outlineViewerRef.current);
      }
    },
    [editor, openOutlinePanel]
  );

  if (!editor || !show) return null;

  return <div className={styles.root} ref={onRefChange} />;
};
